import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { MailWarning } from "lucide-react";

export function VerifyBanner() {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  if (!user || user.email_verified !== false) return null;

  const resend = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/auth/resend-verification");
      setSent(true);
      toast.success(data.message || "Verification email sent.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="verify-banner" className="bg-[#C97C8C]/12 border-b border-[#C97C8C]/25">
      <div className="max-w-6xl mx-auto px-6 py-3 flex flex-wrap items-center gap-3">
        <MailWarning className="w-5 h-5 text-[#C97C8C] shrink-0" />
        <p className="text-sm text-[#2B2622] flex-1 min-w-[200px]">
          Please verify your email address to unlock booking confirmations and updates. We sent a link to <span className="font-medium">{user.email}</span>.
        </p>
        <button
          data-testid="verify-banner-resend"
          onClick={resend}
          disabled={busy || sent}
          className="text-sm rounded-full bg-[#2A2624] hover:bg-[#1E1A18] disabled:opacity-60 text-white px-5 py-2 transition-colors"
        >
          {sent ? "Email sent" : busy ? "Sending…" : "Resend link"}
        </button>
      </div>
    </div>
  );
}
